import { Row, Col } from "reactstrap";
import youth_qr from "../assets/images/SATS club/youth/youth_qr.jpg";
import pic1 from "../assets/images/SATS club/youth/group_discussion1.jpg";
import pic2 from "../assets/images/SATS club/youth/group_discussion2.jpg";

const YouthWingDiscussion = () => {
  return (
    <>
      <div className="container">
        <p>
          <strong>Vanakkam,</strong>
          <br />
          Yet another wonderful initiative by the SATS Youth Wing – a platform
          for our kids to speak and explore the beauty of our Tamil language. We
          kindly encourage you to register your kids and let them be part of
          this fun-filled experience.
        </p>

        <Row className="about-bx3 align-items-start">
          <Col xs="12" md="5">
            <h5
              className="m-t20"
              style={{ color: "#ff6666", textAlign: "center" }}
            >
              இளைஞர் பாசறை வழங்கும்
            </h5>
            <h5 style={{ color: "#ff6666", textAlign: "center" }}>
              "இளையோர் கலந்துரையாடல் மன்றம்"
            </h5>
            <br />
            <p>
              இது SATS இளைஞர் பாசறை பிரிவின் மற்றொரு முயற்சி தமிழில் நடைபெறும்
              மாதாந்திர "இளையோர் கலந்துரையாடல் மன்றம்" இதன் நோக்கம் நம்
              இளந்தலைமுறையினருக்கு தமிழ் பேச மற்றும் தமிழிலக்கியங்களை அறிந்து
              தமிழில் உரையாடுபவர்களாக திகழ்வதற்கு மேடை அமைத்தல் ஒவ்வொரு மாதமும்
              தலைப்புகள் முன்கூட்டியே வழங்கப்பட்டு, தங்களுக்கு விருப்பமான
              வடிவத்தை (கவிதைகள், கட்டுரைகள், உரையாடல்) தேர்ந்தெடுத்து தமிழில்
              தங்கள் எண்ணங்களை குழுவாக பகிர்ந்துரையாடலாம்
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={pic1}
                alt="Group Discussion 1"
                className="img-fluid"
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  height: "250px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginTop: "15px",
                }}
              />
            </div>

            <div
              style={{
                justifyContent: "center",
                paddingTop: 20,
              }}
            >
              <p
                style={{
                  color: "#ff6666",
                  textAlign: "center",
                  lineHeight: "1.6em",
                  fontWeight: 700,
                }}
              >
                தொடக்கம் : செப்டம்பர் 27, சனிக்கிழமை
                <br />
                நேரம் : பின்னர் அறிவிக்கப்படும் <br />
                <br />
                வாங்க பேசலாம் !!
              </p>
            </div>
          </Col>

          <Col xs="12" md="2" className="d-flex justify-content-center mt-5">
            <div className="d-flex justify-content-center mt-5">
              <Col>
                <img
                  className="d-flex justify-content-center mt-5"
                  src={youth_qr}
                  alt="QR Code"
                />

                <h4 style={{ paddingTop: 50, color: "#ff6666" }}>
                  <a
                    href="https://forms.gle/T85CqBkZNLWd7bPt5"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#ff6666", textDecoration: "none" }}
                  >
                    Register here
                  </a>
                </h4>
              </Col>
            </div>
          </Col>

          <Col xs="12" md="5">
            <h5
              className="m-t20"
              style={{ color: "#ff6666", textAlign: "center" }}
            >
              SATS YOUTH WING PRESENTS
            </h5>
            <h5 style={{ color: "#ff6666", textAlign: "center" }}>
              "YOUTH DISCUSSION FORUM IN TAMIL"
            </h5>
            <br />
            <p>
              This is yet another initiative of the SATS Youth wing, conducted
              entirely in Tamil. <br />
              This month "Youth Discussion Forum" aims to provide a platform for
              our younger generation to speak Tamil, explore Tamil literature,
              and engage in meaningful conversations in the language. <br />
              Each month, topics will be shared in advance. Participants may
              choose their preferred format—poem, essay, or dialogue—and present
              their thoughts in Tamil as part of a group discussion.
            </p>{" "}
            <br />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={pic2}
                alt="Group Discussion 2"
                className="img-fluid"
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  height: "250px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginTop: "15px",
                }}
              />
            </div>
            <div
              style={{
                justifyContent: "center",
                paddingTop: 20,
              }}
            >
              <p
                style={{
                  color: "#ff6666",
                  textAlign: "center",
                  lineHeight: "1.6em",
                  fontWeight: 700,
                }}
              >
                Start Date: Saturday, September 27
                <br />
                Time: To Be Announced
                <br />
                <br />
                COME, LET'S TALK TOGETHER !!
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default YouthWingDiscussion;
